import { render, staticRenderFns } from "./TalkSpeak.vue?vue&type=template&id=7df87117&scoped=true&"
import script from "./TalkSpeak.vue?vue&type=script&lang=ts&"
export * from "./TalkSpeak.vue?vue&type=script&lang=ts&"
import style0 from "./TalkSpeak.vue?vue&type=style&index=0&id=7df87117&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df87117",
  null
  
)

export default component.exports